import actions from './actions'
const state = {
  hasGotVIP: false,
  isVIP: false
}
const mutations = {
  updateVIPState(state, data) {
    state.isVIP = data
  },
  updateHasGotVIP(state, data) {
    state.hasGotVIP = data;
  }
}
export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/projects/vipCard/pages/sikuGold/store/index.js